import axios from "axios";
import { config } from "../config";

//Utilities
import { deviceInfo } from "../lib/util";

/*************************************************/
/* BASE SETUP */
/*************************************************/
export let configRequest = axios.create();
export let radiostationsRequest = "";
export let genericRequest = "";

export function apiSetup() {
  genericRequest = axios.create({
    baseURL: `${config.appConfig.reportingUrl}`,
  });

  radiostationsRequest = axios.create({
    baseURL: `${config.appConfig.radiostationUrl}`,
  });
}

export const platform = config.appConfig.requestPlatform;

/*************************************************/
/* METHODS */
/*************************************************/
export function remoteConfigRequest() {
  let url = `${process.env.APP_REMOTE_CONFIG_URL}`;
  return configRequest.get(url);
}

export function getRadiostationsDataRequest() {
  return radiostationsRequest.get();
}

// Errors and any other reports that should come to BE
export function reportingRequest(reportData) {
  return genericRequest.post(`${config.appConfig.reportingUrl}`, reportData, {
    headers: getRequestHeaders(),
  });
}

export function nowNextRequest(radiostationUrl) {
  return genericRequest.get(
    `${config.appConfig.proxyUrl}${radiostationUrl}${
      config.appConfig.nowNextUrlSuffix
    }?${Date.now()}`,
    {
      headers: getRequestHeaders(),
    }
  );
}
/*************************************************/
/* HELPER FUNCTIONS */
/*************************************************/

export function getRequestHeaders(additionalHeaders = {}) {
  const headers = {
    "Content-Type": "application/json",
  };

  return Object.assign(headers, additionalHeaders);
}

export function getRequestBody(additionalProperties = {}) {
  let generalRequestProperties = {
    ownerKey: `${config.appConfig.ownerKey}`,
    deviceId: deviceInfo.metadata.deviceId,
    appPlatform: deviceInfo.platform,
  };

  return Object.assign(generalRequestProperties, additionalProperties);
}

export function getFormData(object) {
  const formData = new FormData();
  Object.keys(object).forEach(key => formData.append(key, object[key]));
  return formData;
}
